import React from 'react';
import { NamedLink } from '../../../..';
import classNames from 'classnames';

import {
  isConflictingItems,
  VIEW_ALL_KEY,
} from '../../../TopbarDesktop/TopbarDropdownMenu/TopbarDropdownMenu.helpers';

import { VIRTUAL_CATEGORY_GROUPS } from '../../../../../config/marketplace-custom-config';

import css from './MenuAccordionSubItem.module.css';

// Helper to build pub_subcategory correctly
const resolvePubSubcategory = key => {
  const group = VIRTUAL_CATEGORY_GROUPS[key];
  return group && group.length ? `has_any:${group.join(',')}` : key;
};

// -----------------------------------------------------------------------------
// MAIN NAV ITEM (Dog Food, Dog Beds, Cat Food, etc.)
// -----------------------------------------------------------------------------
const AccordionSubItemNav = ({
  item,
  toggleActiveSubItem,
  hasOptions,
  conflictingItems,
  mainItem,
}) => {

  // If this item has sub-options, clicking should expand, not navigate
    // If this item has sub-options:
  // - Clicking the LABEL should go to a "view all" search (using VIRTUAL_CATEGORY_GROUPS)
  // - Clicking the + icon should expand/collapse the submenu
  if (hasOptions) {
    const pubSubcategory = resolvePubSubcategory(item.key);

    const toSearch =
      mainItem.key === 'brand'
        ? `pub_brand=${item.key}`
        : conflictingItems
        ? `pub_category=${item.category}`
        : `pub_category=${item.category}&pub_subcategory=${pubSubcategory}`;

    return (
      <div className={css.accordionSubItemNavRow}>

        {/* LEFT SIDE — clicking text opens view-all page */}
        <NamedLink
          className={css.subItemLabel}
          name="SearchPage"
          to={{ search: toSearch }}
          onClick={e => {
            e.stopPropagation(); // DO NOT expand on text tap
          }}
        >
          {item.label}
        </NamedLink>

        {/* RIGHT SIDE — EMPTY SPACE + PLUS both expand */}
        <div
          className={css.expandArea}
          onClick={e => {
            e.preventDefault();
            e.stopPropagation();
            toggleActiveSubItem(item.key); // expand
          }}
        >
          <span className={css.plusIcon} />
        </div>

      </div>
    );
  }



  // Build proper pub_subcategory value for main category links
  const pubSubcategory = resolvePubSubcategory(item.key);

  const toSearch =
    mainItem.key === 'brand'
      ? `pub_brand=${item.key}`
      : conflictingItems
      ? `pub_category=${item.category}`
      : `pub_category=${item.category}&pub_subcategory=${pubSubcategory}`;

  return (
    <NamedLink
      className={css.accordionSubItemNav}
      name="SearchPage"
      to={{ search: toSearch }}
    >
      <span className={css.subItemLabel}>{item.label}</span>
    </NamedLink>
  );
};

// -----------------------------------------------------------------------------
// SUB-ITEM (Dog Dry Food, Vegan Dog Food, Wet Dog Food, etc.)
// -----------------------------------------------------------------------------
const AccordionSubItemLink = ({ item, subItem, conflictingSubItems }) => {

  const pubSubcategory = resolvePubSubcategory(subItem.key);

  const toSearch =
    conflictingSubItems
      ? `pub_category=${item.category}`
      : `pub_category=${item.category}&pub_subcategory=${pubSubcategory}`;

  return (
    <NamedLink
      className={css.accordionSubItemLink}
      key={subItem.key}
      name="SearchPage"
      to={{ search: toSearch }}
    >
      {subItem.label}
    </NamedLink>
  );
};

const MenuAccordionSubItem = props => {
  const { item, activeSubItemKey, setActiveSubItemKey, mainItem } = props;
  const isActiveSubItemKey = activeSubItemKey === item.key;

  const hasOptions =
    item.options?.length > 0 &&
    !(item.options.length === 1 && item.options.find(o => o.key === VIEW_ALL_KEY));

  const conflictingItems = isConflictingItems(item.key);

  const subMenuClasses = classNames(css.accordionSubItem, {
    [css.activeAccordionSubItem]: isActiveSubItemKey,
  });

  const toggleActiveSubItem = key => {
    if (isActiveSubItemKey) {
      setActiveSubItemKey(null);
    } else {
      setActiveSubItemKey(key);
    }
  };

  const subItems = isActiveSubItemKey
    ? item.options.map(subItem => (
        <AccordionSubItemLink
          key={subItem.key}
          item={item}
          subItem={subItem}
          conflictingSubItems={isConflictingItems(subItem.key)}
        />
      ))
    : null;

  return (
    <div className={subMenuClasses}>
      <AccordionSubItemNav
        mainItem={mainItem}
        item={item}
        toggleActiveSubItem={toggleActiveSubItem}
        hasOptions={hasOptions}
        conflictingItems={conflictingItems}
      />
      {subItems}
    </div>
  );
};

export default MenuAccordionSubItem;
